import { zipRecordPermissions } from './recordPermissions'
import type { FgaComputedRelation } from './generated/model'

/**
 * What a caller may do to one agreement: every `can_*` relation the model defines on `agreement`,
 * paired with the camelCase key it is reported under.
 */
export const AGREEMENT_RECORD_PERMISSIONS = [
  ['canView', 'can_view'],
  ['canEdit', 'can_edit'],
  ['canCancel', 'can_cancel'],
  ['canDelete', 'can_delete'],
  ['canViewRelatedSupplier', 'can_view_related_supplier'],
  ['canViewRelatedRequests', 'can_view_related_requests'],
  ['canManageRenewals', 'can_manage_renewals'],
  ['canViewDocuments', 'can_view_documents'],
  ['canEditDocuments', 'can_edit_documents'],
  ['canManageDocuments', 'can_manage_documents'],
  ['canAdminister', 'can_administer'],
] as const satisfies readonly (readonly [string, FgaComputedRelation<'agreement'>])[]

export type AgreementRecordPermissionKey = (typeof AGREEMENT_RECORD_PERMISSIONS)[number][0]

export type AgreementRecordPermissions = Record<AgreementRecordPermissionKey, boolean>

/** The answer for a caller with no access, and the seed every result is built from. */
export const NO_AGREEMENT_RECORD_PERMISSIONS: AgreementRecordPermissions = {
  canView: false,
  canEdit: false,
  canCancel: false,
  canDelete: false,
  canViewRelatedSupplier: false,
  canViewRelatedRequests: false,
  canManageRenewals: false,
  canViewDocuments: false,
  canEditDocuments: false,
  canManageDocuments: false,
  canAdminister: false,
}

export const toAgreementRecordPermissions = (allowed: readonly boolean[]): AgreementRecordPermissions =>
  zipRecordPermissions('agreement', AGREEMENT_RECORD_PERMISSIONS, NO_AGREEMENT_RECORD_PERMISSIONS, allowed)
